import { AnyAction } from "redux";
import { action } from "typesafe-actions";
import { IAgentDashboardInformation } from "./agentDashboard.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import {
    showMessage,
} from "../messages/messagesActions";

// List actions
export const FETCH_AGENT_DASHBOARD_DATA_PROGRESS = "FETCH_AGENT_DASHBOARD_DATA_PROGRESS";
export const FETCH_AGENT_DASHBOARD_DATA_SUCCESS = "FETCH_AGENT_DASHBOARD_DATA_SUCCESS";
export const FETCH_AGENT_DASHBOARD_DATA_FAILURE = "FETCH_AGENT_DASHBOARD_DATA_FAILURE";

export const fetchAgentDashboardDataProgress = () => action(FETCH_AGENT_DASHBOARD_DATA_PROGRESS);

export const fetchAgentDashboardDataSuccess = (
    data: IAgentDashboardInformation[],
    totalRecords: number,
    currentRecords: number,
    totalSum: number
) => action(FETCH_AGENT_DASHBOARD_DATA_SUCCESS, { data, totalRecords, currentRecords, totalSum });

export const fetchAgentDashboardDataFailure = (error: string) =>
    action(FETCH_AGENT_DASHBOARD_DATA_FAILURE, error);

export const fetchAgentDashboardDataAsync =
    (
        forReport: boolean = false,
        query: {
            created_by?: string,
            membership_code?: string,

            status?: string,
            pageNo?: number,
            itemsPerPage?: number,
            from_date?: string,
            to_date?: string,
        }
    ): ThunkAction<Promise<IAgentDashboardInformation[] | void>, IStoreState, {}, AnyAction> =>
        async (dispatch) => {
            try {
                dispatch(fetchAgentDashboardDataProgress());
                let url = "";
                if (forReport === false) {
                    url += `pageNo=${query.pageNo}&itemsPerPage=${query.itemsPerPage}&`;
                }
                if (query.created_by) url += `created_by=${query.created_by}&`;
                if (query.membership_code) url += `membership_code=${query.membership_code}&`;

                if (query.status) url += `status=${query.status}&`;
                if (query.pageNo !== undefined) url += `pageNo=${query.pageNo}&`;
                if (query.itemsPerPage !== undefined) url += `itemsPerPage=${query.itemsPerPage}&`;
                if (query.from_date) url += `from_date=${query.from_date}&`;
                if (query.to_date) url += `to_date=${query.to_date}&`;
                const res = await api.get(`get-agent-activations?${url}`);
                const data: IAgentDashboardInformation[] = res.data.result;
                const totalRecords = res.data.totalRecords;
                const currentRecords = res.data.currentRecords;
                const totalSum = res.data.totalSum;
                if (forReport) {
                    return data;
                }

                dispatch(
                    showMessage({
                        message: "Agent Dashboard Data fetched successfully",
                        type: "success",
                        displayAs: "snackbar",
                    })
                );
                dispatch(fetchAgentDashboardDataSuccess(data, totalRecords, currentRecords, totalSum));
            } catch (error: any) {
                dispatch(fetchAgentDashboardDataFailure(error.message));
                dispatch(
                    showMessage({
                        message: error.response?.data?.message || error.message,
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

// Single record actions
export const FETCH_SINGLE_AGENT_DASHBOARD_DATA_PROGRESS = "FETCH_SINGLE_AGENT_DASHBOARD_DATA_PROGRESS";
export const FETCH_SINGLE_AGENT_DASHBOARD_DATA_SUCCESS = "FETCH_SINGLE_AGENT_DASHBOARD_DATA_SUCCESS";
export const FETCH_SINGLE_AGENT_DASHBOARD_DATA_FAILURE = "FETCH_SINGLE_AGENT_DASHBOARD_DATA_FAILURE";

export const fetchSingleAgentDashboardDataProgress = () =>
    action(FETCH_SINGLE_AGENT_DASHBOARD_DATA_PROGRESS);

export const fetchSingleAgentDashboardDataSuccess = (data: IAgentDashboardInformation) =>
    action(FETCH_SINGLE_AGENT_DASHBOARD_DATA_SUCCESS, data);

export const fetchSingleAgentDashboardDataFailure = (error: string) =>
    action(FETCH_SINGLE_AGENT_DASHBOARD_DATA_FAILURE, error);

export const fetchSingleAgentDashboardDataAsync =
    (id: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch) => {
            try {
                dispatch(fetchSingleAgentDashboardDataProgress());
                const res = await api.get(`get-agent-dashboard-data/${id}`);
                const data: IAgentDashboardInformation = res.data.result;
                dispatch(
                    showMessage({
                        message: "Agent Dashboard Data fetched successfully",
                        type: "success",
                        displayAs: "snackbar",
                    })
                );
                dispatch(fetchSingleAgentDashboardDataSuccess(data));
            } catch (error: any) {
                dispatch(fetchSingleAgentDashboardDataFailure(error.message));
                dispatch(
                    showMessage({
                        message: error.response?.data?.message || error.message,
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

export const CLEAR_AGENT_DASHBOARD_DATA = "CLEAR_AGENT_DASHBOARD_DATA";
export const CLEAR_AGENT_DASHBOARD_DATA_STATE = "CLEAR_AGENT_DASHBOARD_DATA_STATE";
export const clearAgentDashboardData = () => action(CLEAR_AGENT_DASHBOARD_DATA);
export const clearAgentDashboardDataState = () => action(CLEAR_AGENT_DASHBOARD_DATA_STATE);
